<template>
  <Page class="page" :filters="filters">
    <div class="title">{{ $t('report.exportIntroduction') }}</div>
    <div class="subtitle">{{ $t('report.currentSitesTargetSites') }}</div>
    <div class="content">
      <div class="map" :style="{ backgroundImage: `url(${mapUrl})` }"></div>
      <div class="site-container">
        <div v-for="site in currentSites" :key="site.id" class="site">
          <div class="marker current-marker"></div>
          <div class="site-info">
            <div class="site-name">{{ site.name }}</div>
            <div class="site-address">{{ site.address }}</div>
          </div>
        </div>
        <div v-if="targetSites.length > 7" class="target-site-divider"></div>
        <div v-for="site in targetSites.slice(7, 10)" :key="site.id" class="site">
          <div class="marker target-marker" :class="`marker-${site.index + 1}`"></div>
          <div class="site-info">
            <div class="site-name">{{ site.name }}</div>
            <div class="site-address">{{ site.address }}</div>
          </div>
        </div>
      </div>
      <div class="site-container">
        <div v-for="site in targetSites.slice(0, 7)" :key="site.id" class="site">
          <div class="marker target-marker" :class="`marker-${site.index + 1}`"></div>
          <div class="site-info">
            <div class="site-name">{{ site.name }}</div>
            <div class="site-address">{{ site.address }}</div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from '@/components/Report/BasePage';
// import Theme from '@/components/Map/theme'
// import assetProvider from '@/pure/assetProvider'

export default {
  name: 'IntroductionMapPage',

  components: {
    Page,
  },

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    disableCount: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
  },

  data() {
    return {
      mapUrl: null,
    };
  },

  computed: {
    currentSites() {
      if (this.export && this.study) {
        const filteredSites = this.export.sites.map(site => site.id);
        const sites = this.study.sites.filter(s => filteredSites.includes(s.id));
        return sites.filter(s => s.type_id === 1);
      } else {
        return [];
      }
    },

    targetSites() {
      if (this.export && this.study) {
        const filteredSites = this.export.sites.map(site => site.id);
        const sites = this.study.sites
          .filter(s => s.type_id === 2)
          .map((s, i) => {
            s.index = i;
            return s;
          })
          .filter(s => filteredSites.includes(s.id));
        return sites;
      } else {
        return [];
      }
    },
  },

  created() {
    this.$store.dispatch('getExportSiteMap', { id: this.export.public_id }).then(response => {
      this.mapUrl = response.url;
    });
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.page {
  padding: 48px 80px;
  box-sizing: border-box;

  .title {
    display: flex;
    flex-direction: column;
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;
    margin-bottom: 16px;

    &::after {
      content: '';
      margin: 8px 0;
      width: 64px;
      height: 4px;
      border-radius: 4px;
      background: colors.$main-color;
    }
  }

  .subtitle {
    display: flex;
    flex-direction: column;
    font-size: 24px;
    font-weight: 200;
    color: #3c3c3b;
    margin-bottom: 16px;
  }

  .content {
    display: flex;

    .map {
      flex-shrink: 0;
      width: 480px;
      height: 480px;
      background: colors.$grey-color;
      border-radius: 4px;
      pointer-events: none;
      box-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.2);

      background-position: center;
      background-size: cover;
    }

    .site-container {
      margin-left: 24px;
      height: 100%;

      .target-site-divider {
        width: 100%;
        height: 1px;
        background: colors.$grey-color;
        margin: 24px 0 8px;
      }

      .site {
        display: flex;
        margin: 0 0 8px;

        .marker {
          flex-shrink: 0;
          margin: 4px 6px 0 0;
          width: 32px;
          height: 48px;
          background-repeat: no-repeat;
          background-position: center right;
          background-size: contain;

          &.current-marker {
            background-image: url('./../../assets/Marker-home_HOVER.png');
          }
          &.target-marker {
            @for $i from 1 through 10 {
              &.marker-#{$i} {
                background-image: url('./../../assets/Marker-#{$i}.png');
              }
            }
          }
        }

        .site-info {
          font-size: 14px;

          .site-name {
            color: #0f0f0f;
            font-weight: bold;
          }
          .site-address {
            color: #3c3c3b;
          }
        }
      }
    }
  }
}
</style>
